<div [innerHTML]="data.HeaderHtml" (click)="onDataClick($event)"></div>
